import { Component, Input } from '@angular/core';
import { AbstractDashboardDto, DashboardBarChartDto, DashboardGaugeDto, DashboardLineGraphDto, DashboardPieChartDto, DashboardSimpleCountDto } from '../../../../service/dto';

@Component({
  selector: 'app-dashboard-component',
  standalone: false,
  templateUrl: './dashboard-component.component.html',
  styleUrl: './dashboard-component.component.scss'
})
export class DashboardComponentComponent {
	@Input() data?: AbstractDashboardDto;
	@Input() defaultTitle!: string;
	@Input() isLoading!: boolean;

	asDashboardSimpleCountDto(): DashboardSimpleCountDto{
		return this.data as DashboardSimpleCountDto;
	}
	asDashboardLineGraphDto(): DashboardLineGraphDto{
		return this.data as DashboardLineGraphDto;
	}
	asDashboardBarChartDto(): DashboardBarChartDto{
		return this.data as DashboardBarChartDto;
	}
	asDashboardPieChartDto(): DashboardPieChartDto{
		return this.data as DashboardPieChartDto;
	}
	asDashboardGaugeDto(): DashboardGaugeDto{
		return this.data as DashboardGaugeDto;
	}
}
